@if (showBreadCrumbs) {
  <app-bread-crumbs [(breadcrumbs)]="breadcrumbs"></app-bread-crumbs>
}
@if (loading) {
  <span class="spinner-border spinner-border-sm mb-2" role="status" aria-hidden="true"></span>
}
@if (story.content) {
  <div>
    <ndc-dynamic
      [ndcDynamicComponent]="components['page']"
      [ndcDynamicInputs]="story"
      >
    </ndc-dynamic>
  </div>
}
@if (!story.content) {
  <div class="content">
  </div>
}
